import { filter, startWith } from 'rxjs/operators';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  Optional,
  QueryList,
  SkipSelf
} from '@angular/core';

import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-bsg-nav-item',
  styleUrls: ['./cap-navigation.scss'],
  templateUrl: 'cap-nav-item.component.html',
  imports: [
    NgClass,
    NgTemplateOutlet,
    RouterLink,
    TranslatePipe
  ]
})
/**
 * @TODO: Falls  BAG-51 gelöst, navigation hier entfernen.
 */
export class CapNavItemComponent implements AfterContentInit, OnDestroy {
  @Input() target: string; // specifies the window or tab the link should open in. defaults to the current window/tab.
  @Input() href: string; // external links (to other websites)
  @Input() url: string; // internal links (within this app)

  queryParameter: { reset?: boolean } = {};

  @Input() labelKey: string;
  @Input() tooltipKey: string;
  @Input() icon: string;

  @Input() deactivated: boolean;

  @ContentChildren(CapNavItemComponent, { descendants: false })
  childNodes: QueryList<CapNavItemComponent>;

  children = false;

  level: number;

  isExpanded = false;
  isSelected = false;

  classes: { [index: string]: boolean };
  private subscription: Subscription = new Subscription();

  constructor(private router: Router, @Optional() @SkipSelf() public parent: CapNavItemComponent) {
    this.level = (parent ? parent.level : 0) + 1;
  }

  ngAfterContentInit() {
    this.subscription.add(this.childNodes.changes.pipe(startWith(null)).subscribe(() => {
      this.children = this.childNodes.some(x => x !== this); // the content query also matches `this` ...
    }));
    this.subscription.add(this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(<string>null)
    ).subscribe(() => {
      this.isSelected = this.url && this.router.isActive(this.url, this.children);
      this.isExpanded = this.url && this.router.isActive(this.url, false);
      this.updateClasses();
    }));
    this.initializeQueryParameter();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  click() {
    if (this.children) {
      this.isExpanded = !this.isExpanded;
      this.updateClasses();
      return false;
    } else {
      return true;
    }
  }

  updateClasses() {
    this.classes = {
      ['level-' + this.level]: true,
      collapsed: !this.isExpanded,
      expanded: this.isExpanded,
      selected: this.isSelected,
      deactivated: this.deactivated
    };
  }

  /**
   * Suchmasken sollen bei Navigation ueber das Menu zurueckgesetzt werden
   * Dies wird im Moment (Angular 6) ueber einen Query-Parameter reset=true umgesetzt
   * Dieser Query-Parameter wird aber in bestimmten Seiten (Home, System) nicht benoetigt
   */
  initializeQueryParameter() {
    if (!this.url) {
      this.queryParameter = {};
      return;
    }
    const blacklist = ['system/konfiguration', 'system/erweitertes-suchregister', 'home'];
    const urlContainsBlacklistEntry = blacklist.some(element => this.url.includes(element));
    if (!urlContainsBlacklistEntry) {
      this.queryParameter = { reset: true };
    } else {
      this.queryParameter = {};
    }
  }
}
